import * as yup from 'yup';
import { createPhoneNumberValidationSchema } from 'src/shared/form';
import { LoginStrategy } from '../../model';
import { LoginFormModel } from './types';

export const createLoginSchema = (parameters: { loginStrategy: LoginStrategy }): yup.SchemaOf<LoginFormModel> => {
  const { loginStrategy } = parameters;

  return yup.object({
    ...(loginStrategy === LoginStrategy.Phone
      ? {
          phoneNumber: createPhoneNumberValidationSchema(),
          email: yup.string().length(0).optional(),
        }
      : {
          phoneNumber: yup.string().length(0).optional(),
          email: yup
            .string()
            .required('Введите email') // ToDo: replace with translated string
            .email('Неправильный email'),
        }),
    smartToken: yup.string().optional(),
    deviceId: yup.string().optional(),
  });
};
